<!--
  Generated template for the NearbyModifyStartPage page.

  See http://ionicframework.com/docs/components/#navigation for more info on
  Ionic pages and navigation.
-->
<ion-header>

  <ion-toolbar>
    <ion-title>{{ 'NEARBY_MODIFY_START_TITLE' | translate}}</ion-title>
    <ion-buttons end>
      <button ion-button color="primary" (click)="save()">
        {{'GLOBAL_SAVE' | translate}}
      </button>
    </ion-buttons>
  </ion-toolbar>

</ion-header>


<ion-content>

  <ion-list>
    <ion-item>
      <ion-label>{{ 'NEARBY_MODIFY_START_DATE' | translate}}</ion-label>
      <ion-datetime 
      [value]="isoDate"
      (ionChange)="onTimeChange($event)" 
      displayFormat="DD.MM.YYYY" 
      pickerFormat="DD MM YYYY"></ion-datetime>
    </ion-item>
    <ion-item>
      <ion-label>{{ 'NEARBY_MODIFY_START_TIME' | translate}}</ion-label>
      <ion-datetime 
        [value]="isoDate"
        displayFormat="HH:mm"
        (ionChange)="onTimeChange($event)"
      ></ion-datetime>
    </ion-item>
  </ion-list>

</ion-content>
<ion-footer>
  <ion-grid>
    <ion-row>
      <ion-col col-12>
        <p text-center no-margin>{{'NEARBY_MODIFY_START_NOW' | translate}}</p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col col-12>
        <button ion-button block icon-start (click)="now()">
          {{ 'NEARBY_MODIFY_START_START' | translate}}
        </button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>